export default "../fonts/fontawesome-webfont.svg";